import { createSelector } from 'reselect'

import { selectP360PartnerFlagsState } from 'partner360/features/p360PartnerFlags/selectors/selectP360PartnerFlagsState'

export const selectP360PartnerAllFlags = createSelector(
  [selectP360PartnerFlagsState],
  ({ data }) => {
    return data
  }
)
